import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { IReportBoundaries, TableRow } from './report-boundaries.types';
import { ReportBoundriesService } from './report-boundaries.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-boundaries',
    templateUrl: './report-boundaries.component.html',
    styleUrls: ['./report-boundaries.component.scss']
})

export class ReportBoundariesComponent implements OnInit {
    displayedColumns: string[] = ['rowName']; // Initial row column
    headerColumns: string[] = []; // Table headers
    dataSource: any[] = []; // Table data
    newColumnName: string = '';
    editingColumnName: string | null = null; // Track column being edited
    editedValues: any = {}; // Store edited values before saving
    dialogTitle = 'Boundaries';
    previousIndex: number;
    editingColumn: { [key: string]: string } = {}; // Store temporary column names
    reportId: number;
    rowOrder = ["N", "S", "E", "W"];
    rowDisplayNames: { [key: string]: string } = {
        N: "North",
        S: "South",
        E: "East",
        W: "West",
    };
    transformedData: TableRow[] = [];
    plotCount: { [key: string]: { [columnName: string]: number } } = {};
    boundries: IReportBoundaries[] = [];

    constructor(private _matDialogRef: MatDialogRef<ReportBoundariesComponent>,
        private _alertMessageService: AlertMessageService,
        private _boudriesservice: ReportBoundriesService,
        @Inject(MAT_DIALOG_DATA) private _data: {
            boundaries: any,
            title: string,
            reportId: number
        },
    ) {
        this.dialogTitle += ` for As Per ${_data.title}`;
        this.reportId = this._data.reportId;
    }

    ngOnInit(): void {
        this.getBoundriesValue();
    }

    onClose(): void {
        this._matDialogRef.close();
    }

    saveReportBoundries() {

        const saveBoundries = {
            reportId: this.reportId,
            boundriesType: this._data.title.toLowerCase(),
            reportBoundriesValue: this.getBoundriesObject()
        }

        this._boudriesservice.createBoundire(saveBoundries).subscribe((response) => {
            if (response.isSuccess) {
                this._alertMessageService.success("Bounderies Created Successfully");
                this._matDialogRef.close(response);
            } else {
                this._alertMessageService.error(response.errors.join("\n"));
            }
        })
    }

    getBoundriesObject() {
        this.boundries = [];
        this.dataSource.forEach((row) => {
            // console.log(row, "<=datasourse row value");
            Object.keys(row).forEach((columnName, index) => {
                if (columnName !== 'rowName') {
                    this.boundries.push({
                        rowName: row.rowName,
                        columnName: columnName,
                        value: row[columnName],
                        orderIndex: index,
                        reportId: this.reportId,
                        boundriesType: this._data.title
                    });
                }
            });
        });

        return this.boundries;
    }


    getBoundriesValue() {
        const btype = this._data.title.toLowerCase();
        this._boudriesservice.getBoundries(this.reportId, btype).subscribe((res) => {
            if (res) {
                if (res.isSuccess && res.result.length > 0) {
                    const rawData = res.result.sort((a, b) => {
                        if (a.orderIndex < b.orderIndex) return -1;
                        if (a.orderIndex > b.orderIndex) return 1;
                        return this.rowOrder.indexOf(a.rowName) - this.rowOrder.indexOf(b.rowName);
                    });
                    let tableMap: any = {}; // Map to group data by rowName
                    let columnSet = new Set<string>(); // Unique column names

                    rawData.forEach(item => {
                        if (!tableMap[item.rowName]) {
                            tableMap[item.rowName] = { rowName: item.rowName };
                        }
                        tableMap[item.rowName][item.columnName] = item.value || '';

                        columnSet.add(item.columnName); // Add column to unique set
                    });

                    this.displayedColumns = ['rowName', ...Array.from(columnSet)];
                    this.headerColumns = [...this.displayedColumns];
                    this.dataSource = Object.values(tableMap);

                    // Initialize column editing tracker
                    this.displayedColumns.forEach(col => this.editingColumn[col] = col);
                } else {
                    const defaultData = [
                        {
                            "rowName": "N",
                            "columnName": "1",
                            "value": "",
                            "orderIndex": 1,
                        },
                        {
                            "rowName": "S",
                            "columnName": "1",
                            "value": "",
                            "orderIndex": 1,
                        },
                        {
                            "rowName": "E",
                            "columnName": "1",
                            "value": "",
                            "orderIndex": 1,
                        },
                        {
                            "rowName": "W",
                            "columnName": "1",
                            "value": "",
                            "orderIndex": 1,
                        },
                    ]

                    let tableMap: any = {}; // Map to group data by rowName
                    let columnSet = new Set<string>(); // Unique column names

                    defaultData.forEach(item => {
                        if (!tableMap[item.rowName]) {
                            tableMap[item.rowName] = { rowName: item.rowName };
                        }
                        tableMap[item.rowName][item.columnName] = item.value || '';

                        columnSet.add(item.columnName); // Add column to unique set
                    });

                    this.displayedColumns = ['rowName', ...Array.from(columnSet)];
                    this.headerColumns = [...this.displayedColumns];
                    this.dataSource = Object.values(tableMap);

                    // Initialize column editing tracker
                    this.displayedColumns.forEach(col => this.editingColumn[col] = col);
                }
            }
        });

    }

    // Add a new column dynamically (only on UI)
    addColumn(): void {
        this.newColumnName = `Plot ${this.displayedColumns.length}`

        this.displayedColumns.push(this.newColumnName);
        this.headerColumns.push(this.newColumnName);
        // Assign empty values for all rows to prevent undefined issue
        this.dataSource.forEach(row => {

            if (!row[this.newColumnName]) {
                row[this.newColumnName] = ''; // Initialize empty value instead of undefined
            }
        });

        this.newColumnName = '';
    }


    editValue(row: any, column: string, event: any): void {
        const newValue = event.target.value;
        if (!this.editedValues[row.rowName]) {
            this.editedValues[row.rowName] = {};
        }
        this.editedValues[row.rowName][column] = newValue;
    }

    // Start inline editing for a column name
    startEditingColumn(column: string): void {
        this.editingColumnName = column;
    }

    // Update column name on "Enter" or blur
    updateColumnName(oldColumnName: string, event: any): void {
        const newColumnName = event.target.value.trim();

        if (!newColumnName || newColumnName === oldColumnName) {
            this.editingColumnName = null;
            return; // No changes
        }

        if (this.displayedColumns.includes(newColumnName)) {
            this._alertMessageService.error("Column name already exists!");
            this.editingColumnName = null;
            return;
        }

        // Update displayed columns
        this.displayedColumns = this.displayedColumns.map(col =>
            col === oldColumnName ? newColumnName : col
        );
        this.headerColumns = [...this.displayedColumns];

        // Update data structure
        this.dataSource.forEach(row => {
            row[newColumnName] = row[oldColumnName];
            delete row[oldColumnName];
        });


        this.editingColumnName = null;
    }

    // Remove column dynamically
    removePlotColumn(column: string): void {

        if (this.displayedColumns.length === 1) {
            this._alertMessageService.error("Don't Deleted First column...");
            return;
        } else {
            this.displayedColumns = this.displayedColumns.filter(col => col !== column);
            this.headerColumns = this.headerColumns.filter(col => col !== column);
            this.dataSource.forEach(row => {
                delete row[column];
            });
        }

    }
}
